module.exports = __webpack_public_path__ + "static/media/1212123.f6e46535.jpg";